import Axios from 'axios';

const defaultBaseURL = process.env.VUE_APP_API;
const trainingBaseURL = process.env.VUE_APP_API_TRAINING;
const trainingSessionKey = 'somia:isTraining';

function getIsTraining() {
  if (typeof window === 'undefined') return false;

  const { pathname, search } = window.location;
  const params = new URLSearchParams(search);

  if (pathname === '/screening-result-cms') {
    const isTraining = params.get('isTraining') === 'true';
    window.sessionStorage.setItem(trainingSessionKey, String(isTraining));
    return isTraining;
  }

  return window.sessionStorage.getItem(trainingSessionKey) === 'true';
}

const axios = Axios.create({
  baseURL: defaultBaseURL,
});

axios.interceptors.request.use((config) => {
  config.baseURL = getIsTraining() ? trainingBaseURL : defaultBaseURL;
  return config;
});

export default axios;
